import { useSendChatMessage } from "@/features/Chat/hooks/useSendChatMessage";
import { ChatActionType } from "@/features/Chat/network/useChatAvailableActions";
import { VIDEO_CALL_EVENT } from "@/features/Chat/types/chatMessageTypes";
import { useRoomToken } from "@/features/Patient/network/useRoomToken";
import { useDailyEvent, useInputSettings } from "@daily-co/daily-react";
import { useParams } from "@tanstack/react-router";
import { useSearch } from "@tanstack/react-router";
import { useCallback } from "react";

export const useDailyEventHandling = () => {
  const { encounterId } = useSearch({ from: "/patient/$patientId" });
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const { updateInputSettings } = useInputSettings();

  // AV is Live only
  const { sendVideoMessage } = useSendChatMessage({
    chatMode: ChatActionType.LIVE_CHAT,
  });
  const { data: roomToken } = useRoomToken({
    encounterId: encounterId?.toString(),
    patientId: patientId,
  });

  useDailyEvent(
    "participant-joined",
    useCallback(() => {
      sendVideoMessage({
        videoCallEvent: VIDEO_CALL_EVENT.PATIENT_JOINED,
        roomToken: roomToken || "",
      });
    }, [sendVideoMessage, roomToken]),
  );

  useDailyEvent(
    "joined-meeting",
    useCallback(() => {
      // send video call message
      sendVideoMessage({
        videoCallEvent: VIDEO_CALL_EVENT.PROVIDER_JOINED,
        roomToken: roomToken || "",
      });
      updateInputSettings({
        video: {
          processor: {
            type: "background-blur",
            config: { strength: 1 },
          },
        },
      });
    }, [updateInputSettings, sendVideoMessage, roomToken]),
  );

  useDailyEvent(
    "left-meeting",
    useCallback(() => {
      sendVideoMessage({
        videoCallEvent: VIDEO_CALL_EVENT.PROVIDER_LEFT,
        roomToken: roomToken || "",
      });
    }, [sendVideoMessage, roomToken]),
  );
};
